import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("code", {
    class: "bg-black rounded-md p-1 whitespace-nowrap",
    innerHTML: _ctx.codeTree
  }, null, 8 /* PROPS */, _hoisted_1))
}